var URI = {
    init: function() {
        var href = window.location.href;
        var array = href.split('#/');

        if (typeof array[1] === 'undefined') {
            window.location.href = '#/home';
            // var no = href.split("/");
            // if (!no[3]) {
            //     var no = no[3].split("?");
            //     if (no[0] != "noticia") {
            //         window.location.href = '#/home';
            //     };
            // };
        } else {
            URI.exec(array[1]);
            // URI.selectMenu(array[1]);
        }
    },

    change: function() {
        var href = window.location.href;
        var array = href.split('#/');
        // var dd = array[1].split('/');

        if (typeof array[1] !== 'undefined') {
            // $(".site-navbar-nav li.active").removeClass('active');
            // URI.selectMenu(array[1]);
            URI.exec(array[1]);
            // (<any>$(".navbar-collapse")).collapse('hide');
        }
    },

    exec: function(action: any) {
        $('#content').html('').addClass('content-loading');
        $.post('/load', { action: action }, function(r) {
            $('#content').html(r).removeClass('content-loading');
        });
    }

    // selectMenu: function (ac: any) {
    //     var dd = ac.split('/');

    //     if ($("#li-" + dd[0]).length > 0) {
    //         $("#li-" + dd[0]).addClass('active');
    //     }
    // }
};

window.onhashchange = function() {
    URI.change();
    // $('body, html').animate({ scrollTop: 0 }, 900);
};

// var URI = {

//     init : function()
//     {
//         var wh = window.location.href;
//         var ac = wh.split("#/");

//         if(typeof ac[1] === 'undefined')
//         {

//             var no = wh.split("/");
//             if (!no[3]) {
//                 var no = no[3].split("?");
//                 if (no[0] != "noticia") {
//                     window.location = '#/home';
//                 };
//             };

//         } else {
//             URI.exec(ac[1]);
//             //classe do menu superior
//             $(".sh-menuitem-active").removeClass('sh-menuitem-active');
//             if (ac[1] == 'camara/vereadores'){
//                 var id = ac[1].split("camara/");
//                 $('#'+id[1]).addClass('sh-menuitem-active');
//             }else if(ac[1] == 'home') {
//                 $('#'+ac[1]).addClass('sh-menuitem-active');
//             }
//         }
//     },

//     change : function()
//     {
//         var wh = window.location.href;
//         var ac = wh.split("#/");

//         if(typeof ac[1] !== 'undefined'){
//             $(".sh-menuitem-active").removeClass('sh-menuitem-active');
//             URI.exec(ac[1]);
//             //classe do menu superior
//             if (ac[1] == 'camara/vereadores'){
//                 var id = ac[1].split("camara/");
//                 $('#'+id[1]).addClass('sh-menuitem-active');
//             }else if(ac[1] == 'home') {
//                 $('#'+ac[1]).addClass('sh-menuitem-active');
//             }
//         }

//     },

//     exec : function(ac, title)
//     {
//         if(typeof title != 'undefined')
//             document.title = window.changetitle;

//         $('#content').html('').addClass('content-loading');
//         $.post('/carregar',{action: ac},function(r){
//             $('#content').html(r).removeClass('content-loading');
//         });
//     }

// }
